import { render, staticRenderFns } from "./CadastroRegra.vue?vue&type=template&id=d755e816&scoped=true"
import script from "./CadastroRegra.vue?vue&type=script&lang=js"
export * from "./CadastroRegra.vue?vue&type=script&lang=js"
import style0 from "./CadastroRegra.vue?vue&type=style&index=0&id=d755e816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d755e816",
  null
  
)

export default component.exports